import styled from 'styled-components';

export const AuthContainer = styled.div`
  .info-container {
    height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 260px;
    animation-name: panel_text;
    animation-duration: 2s;

    .subheadline {
      line-height: normal;
      font-weight: 300;
      position: relative;
      display: inline-block;
      font-family: 'Manrope', sans-serif;
      font-size: 56px;
      z-index: 1;
    }
  }
  @keyframes panel_text {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const QuantcastLogo = styled.div`
  background-position: center;
  background-size: contain;
  background-image: url("https://static.quantcast.com/images/quantcast-logo-black.svg");
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
  min-height: 65.39px;
  width: 354px;
  margin-top: 50px;
`;

export const FooterHolder = styled.footer`
    background: none repeat scroll 0 0 transparent;
    text-align: center;
    width: 100%;
    height: 20px;
    padding-top: 13px;
    padding-bottom: 30px;
  `;

export const Footer = styled.div`
    margin: auto;
    width: 400px;
  `;

export const FooterLink = styled.span`
    margin: 1em;    
`;

export const BoxCaptcha = styled.div`
    background-color: #fff;
    border-color: #ddd #ddd #d8d8d8;
    box-shadow: 0 2px 0 hsla(0,0%,68.6%,.12);
    overflow: auto;
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 400px;
    min-width: 300px;
`;